import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded';
import { Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { getOrCreateLeaderboard } from '../api/leaderboard_api';

function formatPercent(value) {
  return `${Math.round(value * 100)}%`;
}

function getDeviceStats(leaderboard, deviceId) {
  const entries = Array.isArray(leaderboard?.entries) ? leaderboard.entries : [];
  const deviceEntry = entries.find((entry) => (entry.deviceId || entry.id) === deviceId) || {};
  const correct = Number(deviceEntry.correct ?? deviceEntry.score) || 0;
  const total = Number(deviceEntry.total) || 0;

  return {
    correct,
    total,
    winStream: Number(deviceEntry.winStream) || 0,
    accuracy: Number.isFinite(Number(deviceEntry.accuracy))
      ? Number(deviceEntry.accuracy)
      : total > 0
        ? correct / total
        : 0,
  };
}

function ResultsScreen({ deviceId, playerName, onNavigate }) {
  const [stats, setStats] = useState({
    correct: 0,
    total: 0,
    winStream: 0,
    accuracy: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    setLoading(true);

    getOrCreateLeaderboard({ deviceId, playerName })
      .then((leaderboard) => {
        if (isMounted) {
          setStats(getDeviceStats(leaderboard, deviceId));
        }
      })
      .finally(() => {
        if (isMounted) {
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [deviceId, playerName]);

  return (
    <Box className="screen">
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Typography variant="overline" color="text.secondary">
          Global stats
        </Typography>
        {loading ? (
          <Stack spacing={1} alignItems="flex-start">
            <CircularProgress size={24} />
            <Typography color="text.secondary">Loading score</Typography>
          </Stack>
        ) : (
          <Typography variant="h1">{formatPercent(stats.accuracy)}</Typography>
        )}
        <Typography color="text.secondary">
          Best win streak {stats.winStream}. {stats.correct} correct from {stats.total} total answer
          {stats.total === 1 ? '' : 's'}.
        </Typography>

        <Card>
          <CardContent>
            <Typography color="text.secondary">
              Rounds now continue forever. Your score updates through the leaderboard API after every answer.
            </Typography>
          </CardContent>
        </Card>

        <Stack spacing={1.25}>
          <Button variant="contained" size="large" startIcon={<ReplayRoundedIcon />} onClick={() => onNavigate('/game')}>
            Keep Playing
          </Button>
          <Button variant="outlined" size="large" startIcon={<BarChartRoundedIcon />} onClick={() => onNavigate('/scores')}>
            View Leaderboard
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}

export default ResultsScreen;
